import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { DialogStackService } from './dynamic-dialog-overflow.service';

export function provideDialogStackService(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DialogStackService,
    provideAppInitializer(() => {
      const service = inject(DialogStackService);
      service.init();
    }),
  ]);
}
